import { render, staticRenderFns } from "./InvoiceItems.vue?vue&type=template&id=feca27a4&scoped=true&"
import script from "./InvoiceItems.vue?vue&type=script&lang=js&"
export * from "./InvoiceItems.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceItems.vue?vue&type=style&index=0&id=feca27a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../local-cache/custom/dba27c31aad935787bb275c3e5e4e957708f15386de599eff1db476022cd7e4c/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feca27a4",
  null
  
)

export default component.exports